import React from "react";

interface CurrencyDropdownProps {
  value: "RON" | "EUR";
  onChange: (currency: "RON" | "EUR") => void;
  className?: string;
}

const options = [
  { label: "RON", value: "RON" },
  { label: "EUR", value: "EUR" },
];

const CurrencyDropdown: React.FC<CurrencyDropdownProps> = ({
  value,
  onChange,
  className = "",
}) => {
  return (
    <div className={`relative inline-block w-32 ${className}`}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as "RON" | "EUR")}
        className="block w-full bg-gray-800 text-white font-bold px-6 rounded-lg appearance-none focus:outline-none focus:ring-2 focus:ring-primary transition-all text-xl min-w-[90px] h-[88px] pt-0 pb-0 flex items-center"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="text-black text-xl">
            {opt.label}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4 text-white">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </div>
  );
};

export default CurrencyDropdown;